import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import MakeInvoiceEntityForm from "../../Account/Balance/MakeInvoiceEntityForm";

export default (props) => {

    const {
        putBalance,
        putBalanceConfirm,
        closePutBalance,
        handleAmount,
        selectedCompany,
    } = props;

    const {
        type,
        show,
        amount,
        is_need_original,
        email_for_original,
        isFetching,
        email,
        token,
        authtoken,
    } = putBalance;

    let wHeight = window.innerHeight;

    return (
        <SweetAlert
            type={type}
            show={show}
            style={wHeight <= 550 ? {top:'0', marginTop:0,height:'100%',overflowY:'auto'} : {}}
            confirmBtnCssClass={`alert-btn-confirm ${isFetching ? 'disabled' : ''}`}
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'default' ? true : false}
            confirmBtnText={"Продолжить"}
            cancelBtnText={type === "default" ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={'Пополнение баланса'}
            onConfirm={() => isFetching ? false : (type === 'default') ? putBalanceConfirm() : closePutBalance()}
            onCancel={() => closePutBalance()}
        >
            {
                type === 'success'
                ?
                <div>
                    <label style={{display:'block'}}>Операция прошла успешно</label>
                    <label style={{display:'block'}}>После подтверждения администратора сумма будет перечислена на счёт компании</label>
                     <a style={{display:'block'}}
                        href={`${window.siteUrl}/api/v1/make-invoice/${selectedCompany.id}/?amount=${amount}&authtoken=${authtoken}&token=${token}&email=${email}&is_need_original=${is_need_original}&email_for_original=${email_for_original}`}
                        target="_blank"
                        >
                        Распечатать квитанцию
                    </a>
                </div>
                :
                <MakeInvoiceEntityForm {...props} />
            }
        </SweetAlert>
    )
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashInEntityModal.js